import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import {Glyphicon, Media, OverlayTrigger, Tooltip} from 'react-bootstrap';
import groupImg from './img/group.svg';
import ContactsList from './ContactsList'
import NewGroupParticipantsSelect from './NewGroupParticipantsSelect'
import NewGroupSubject from './NewGroupSubject'
import MainBtn from './MainBtn'
import {NEW_GROUP_FORM_STATE} from './constants'
import {inject, observer} from "mobx-react";

@inject('contactsStore') @observer
class NewGroup extends React.Component {
  
  render(){
    return(
      <div>
        {this.renderAccordingToContainerState()}
      </div>
    );
  }

  renderAccordingToContainerState(){
    let elementToRender;
    switch(this.props.viewState){
      case NEW_GROUP_FORM_STATE.PARTICIPANTS_SELECTION:
        elementToRender = this.renderParticipantsSelection();
        break;
      case NEW_GROUP_FORM_STATE.SUBJECT_DEFINITION:
        elementToRender = this.renderSubjectDefinition();
        break;
    }
    return( 
      <div>
        {elementToRender}
      </div>
    );
  }

  renderParticipantsSelection(){
    return(
      <NewGroupParticipantsSelect
        selection={this.props.participants}
        onAddParticipantClick={this.props.onAddParticipantClick}
        onRemoveParticipantClick={this.props.onRemoveParticipantClick}
        onSubmit={this.props.onParticipantsSubmit}
      />
    );
  }

  renderSubjectDefinition(){
    return(
      <NewGroupSubject
        participants={ this.props.contactsStore.getParticipantsInSelection(this.props.participants)}
        onSubmit={this.props.onSubjectSubmit}
      />
    );
  }

}

export default injectIntl(NewGroup);